import React, { Component } from "react";
import styled from "styled-components";

const Icon = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 100px;
  cursor: pointer;
`;

class IconList extends Component {
  state = {};
  render() {
    const { primary, image, onClick } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginRight: "10px"
        }}
        onClick={onClick}
      >
        <Icon src={image} />
        {primary}
      </div>
    );
  }
}

export default IconList;
